// extracted by mini-css-extract-plugin
export var notifyBar = "NotificationBar-module--notifyBar--3qHQL";
export var blue = "NotificationBar-module--blue--14HoZ";
export var fsPink = "NotificationBar-module--fs-pink--ESd0M";
export var spark = "NotificationBar-module--spark--vxH33";
export var show = "NotificationBar-module--show--3W1cP";
export var hide = "NotificationBar-module--hide--10WPw";
export var notifyBarText = "NotificationBar-module--notifyBarText--uBnVx";
export var crossIcon = "NotificationBar-module--crossIcon--33dQR";
export var bounceArrow = "NotificationBar-module--bounceArrow--2Qya8";